<div class="row otp-wrapper" *ngIf="!isLoading && !isConsent && stateDialog === ''">
    <div class="col-12">
        <img src="assets/img/otp-icon.png" class="otp-icon" />
        <p class="otp-title"> {{ "otp" | translate }}</p>
        <p class="otp-sent"> {{ "otp_sent" | translate }}</p>
        <p class="indosat">
            via <img src="assets/img/sms-icon.png" class="otp-icon" />
            {{ "to" | translate }}
            <b class="indosat-bold">62{{ msisdn }}</b>
        </p>
        <p class="p-2 indosat">{{ "input_code" | translate }}</p>
    </div>

    <div class="col-2 col-sm-1 px-0 mx-sm-2">
        <!-- <input class="form-control otpbox text-center {{
            (validationMsg && validationMsg !== '') ? 'otperrinput' : ''
          }}" [(ngModel)]="otp1" id="firstotp" name="firstotp" #firstotp [ngModelOptions]="{ standalone: true }"
            (keyup)="onDigitInput($event, 1)" (click)="onDigitInput($event, 1)" maxlength="1" /> -->
        <input class="form-control otpbox text-center {{
                        (validationMsg && validationMsg !== '') ? 'otperrinput' : ''
                      }}" [(ngModel)]="otp1" id="firstotp" name="firstotp" #firstotp
            [ngModelOptions]="{ standalone: true }" (keyup)="onDigitInput($event, 1)" maxlength="1" />
    </div>
    <div class="col-2 col-sm-1 px-0 mx-sm-2">
        <input class="form-control otpbox text-center {{
            (validationMsg && validationMsg !== '') ? 'otperrinput' : ''
          }}" [(ngModel)]="otp2" id="secondotp" name="secondotp" #secondotp [ngModelOptions]="{ standalone: true }"
            (keyup)="onDigitInput($event, 2)" maxlength="1" />
    </div>
    <div class="col-2 col-sm-1 px-0 mx-sm-2">
        <input class="form-control otpbox text-center {{
            (validationMsg && validationMsg !== '') ? 'otperrinput' : ''
          }}" [(ngModel)]="otp3" id="thirdotp" name="thirdotp" #thirdotp [ngModelOptions]="{ standalone: true }"
            (keyup)="onDigitInput($event, 3)" maxlength="1" />
    </div>
    <div class="col-2 col-sm-1 px-0 mx-sm-2">
        <input class="form-control otpbox text-center {{
            (validationMsg && validationMsg !== '') ? 'otperrinput' : ''
          }}" [(ngModel)]="otp4" id="fourthotp" name="fourthotp" #fourthotp #4otp
            [ngModelOptions]="{ standalone: true }" (keyup)="onDigitInput($event, 4)" maxlength="1" />
    </div>
    <div class="col-2 col-sm-1 px-0 mx-sm-2">
        <input class="form-control otpbox text-center {{
            (validationMsg && validationMsg !== '') ? 'otperrinput' : ''
          }}" [(ngModel)]="otp5" id="fifthotp" name="fifthotp" #fifthotp [ngModelOptions]="{ standalone: true }"
            (keyup)="onDigitInput($event, 5)" maxlength="1" />
    </div>
    <div class="col-2 col-sm-1 px-0 mx-sm-2">
        <input class="form-control otpbox text-center {{
            (validationMsg && validationMsg !== '') ? 'otperrinput' : ''
          }}" [(ngModel)]="otp6" id="sixthotp" name="sixthotp" #sixthotp [ngModelOptions]="{ standalone: true }"
            (keyup)="onDigitInput($event, 6)" maxlength="1" />
    </div>
    <div class="col-12 mt-3" *ngIf="(validationMsg && validationMsg !== '')">
        <p class="otperrtext">{{ validationMsg }}</p>
    </div>
    <div class="col-12 mt-4 indosat">
        {{ "didnt_receive" | translate }}
        <span class="resend indosat-bold" [ngClass]="{ 'disabled': !isResendOtp }" (click)="resend()">
            {{ "resend_code" | translate }}
        </span>
        <p class="mt-3 indosat-bold">
            {{ showmin | number: "2.2-2" | slice: 0:2 }}:{{
            showsec | number: "2.0"}}
        </p>
    </div>
    <div class="col-12 mt-4">
        <button class="btn-verify" [ngClass]="{ 'btn-disabled' : inputotp.length !== 6 }" type="button"
            (click)="verify()">
            {{ "verify" | translate}}
        </button>
        <button class="btn-cancel" type="button" (click)="cancel()">
            {{ "cancel" | translate}}
        </button>
    </div>
</div>
<div class="content" *ngIf="stateDialog !== '' ">
    <div class="text-center px-4">
        <app-dialog [dialogType]="stateDialog" [showButton]="showButton" (btnAction)="btnAction()"></app-dialog>
    </div>
</div>


<app-loading *ngIf="isLoading && !isConsent"></app-loading>

<app-consent *ngIf="isConsent" [consent]="consent" [msisdn]="msisdn" [signature]="signature"
    [isAutoLogin]="isAutoLogin"></app-consent>

<!-- <app-consent-withoutradio *ngIf="isConsent" [consentType]="consentType" [msisdn]="msisdn" [signature]="signature"
    [isAutoLogin]="isAutoLogin"></app-consent-withoutradio> -->

<app-toast [showToast]="showToast" [typeToast]="typeToast" [messageToast]="messageToast"
    (closeToast)="showToast = false"></app-toast>